import React, { Fragment, ReactElement, useEffect } from 'react';
import { Controller, useController, UseControllerProps } from 'react-hook-form';
import { Form, Label } from 'semantic-ui-react';
import { getLabel } from './util';

interface ExternalProps extends UseControllerProps {
  children: ReactElement;
  onChange?: (...args: any[]) => any;
  label?: string | JSX.Element;
  [prop: string]: any;
  control: any;
  noErrorMessage?: boolean,
}

const External: React.FC<ExternalProps> = (props) => {
  const { field, fieldState } = useController(props);
  const { control, children, name, rules, label, noErrorMessage, keyName, ...externalProps } = props;
  const fieldTemp = { ...field, ref: null as any };

  function notInViewport(element: any, offset = 0) {
    if (!element) return false;
    const top = element.getBoundingClientRect().top;
    return top + offset >= 0 && top - offset >= window.innerHeight;
  }

  useEffect(() => {
    if (fieldState.error) {
      const element = document.getElementById(fieldTemp.name);
      if (notInViewport(element)) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [fieldState, keyName, props.rules, field])

  return (
    <Form.Field>
      {label && getLabel(label, rules, fieldState)}
      <Controller
        control={control}
        name={name}
        render={() => {
          const ChildComponent = React.cloneElement(children, {
            ...fieldTemp,
            ...externalProps,
            id: props.id || fieldTemp.name,
            value: keyName || fieldTemp.value
          });
          return (
            <Fragment>
              {ChildComponent}
            </Fragment>
          );
        }}
      />
    </Form.Field>
  );
};
export default External;
